export const __updateCommentObject = (post, updatedCommentObject) =>{

    if (updatedCommentObject?.parent){
        const parentIndex = post.comments.findIndex(comment=>comment?.id === updatedCommentObject?.parent)
        const childCommentIndex = post.comments[parentIndex].child.findIndex(comment=>comment?.id === updatedCommentObject?.id)
        post.comments[parentIndex].child[childCommentIndex] = {...updatedCommentObject}
    }else{
        const commentIndex = post.comments.findIndex(comment=>comment?.id === updatedCommentObject?.id)
        post.comments[commentIndex] = {...updatedCommentObject}
    }

    return post

}


export const __determineActivityType = (state) => {

    if (state.activeKey.name === 'myactivity' || state.activeKey.name === 'feed'){
        return {commentsMap:state.feedComments, activityName: state.activeKey.name }
    }else if (state.activeKey.name === 'comments'){
        return {commentsMap:state.commentActivity, activityName: state.activeKey.name}
    }

    // return {commentsArray: state.feedComments, activityName: state.activeKey.name}
}
